/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconUpload, IconX } from "@tabler/icons-react";
import SelectInput from "../../../components/Select";
import CoverageCities from "./CoverageCities";
import {
  useDistrictFetchData,
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../../apis/locationApis";
import {
  useCreateCoverageMutation,
  useUpdateCoverageMutation,
  useWarehouseListData,
} from "../../../apis/warehouseApi";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useProfileData } from "../../../apis/profileApis";
import Input from "../../../components/Input";
import TextArea from "../../../components/common/TextArea";
import ToggleButton from "../../../components/ToggleButton";
import FileUploader from "../../../components/common/FileUploader";
import MultiSelectInput from "../../../components/common/MultiSelectInput";
import Radio from "../../../components/common/Radio";

type CoverageFormValues = {
  warehouseId: string;
  covrageCountry: string;
  covrageName: string;
  covrageCity: string;
  covrageType: string;
  covrageCities: string[];
  status?: boolean;
};

export default function EditCoverageModal({
  onClose,
  selectedWarehouse,
  warehouseDetails,
}: {
  onClose: () => void;
  selectedWarehouse: string;
  warehouseDetails: any;
}) {
  console.log(warehouseDetails, "warehouseDetailswarehouseDetails");
  const [selectedCitiesArray, setSelectedCitiesArray] = useState<any>();
  const [selectedCoverageCountry, setSelectedCoverageCountry] = useState<any>();
  const [selectedCoverageCity, setSelectedCoverageCity] = useState<any>();
  const [error, setError] = useState<string>("");
  const { data } = useFetchCountriesAllData();
  const { data: citiesData, refetch: countryRefetch } =
    useFetchCountryCitiesAllData(selectedCoverageCountry?.id);
  const { data: districtData, refetch: districtRefetch } = useDistrictFetchData(
    selectedCoverageCity?.id
  );
  const [checked, setChecked] = useState<boolean>(false);
  const [coverageDataList, setCoverageDataList] = useState<any[]>([]);
  const { mutate: coverageMutate } = useUpdateCoverageMutation();
  const { data: warehouseData, refetch } = useWarehouseListData();
  const { refetch: profileFetch } = useProfileData();

  const {
    register: coverageRegister,
    handleSubmit: coverageSubmit,
    clearErrors: coverageClearErrors,
    reset: coverageReset,
    watch: coverageWatch,
    formState: { errors: coverageErrors },
    setValue,
  } = useForm<CoverageFormValues>();

  useEffect(() => {
    if (warehouseDetails?.covrage?.length > 0) {
      setCoverageDataList(warehouseDetails?.covrage);
    }
  }, [warehouseDetails?.covrage]);

  const handleCreate = (formData: CoverageFormValues) => {
    if (selectedCitiesArray?.length === 0) {
      setError("Please select minimum one city");
      toast.error("Please select at least one city");
      return;
    } else {
      setError("");
    }
    let country: any = coverageWatch("covrageCountry");
    let city: any = coverageWatch("covrageCity");

    coverageMutate(
      {
        ...formData,
        covrage: selectedCitiesArray,
        warehouseId: selectedWarehouse,
        covrageCountry:
          coverageWatch("covrageType") === "city" ||
          coverageWatch("covrageType") === "district"
            ? country?.id
            : null,
        covrageCity:
          coverageWatch("covrageType") === "district" ? city?.id : null,
        coverageId: warehouseDetails?.id,
      },
      {
        onSuccess: (data) => {
          coverageReset();
          onClose();
          refetch();
          profileFetch();
          toast.success("Coverage updated successfully!");
        },
        // onError: (error) => {
        //   console.log(error, "error");
        //   toast.error(`${error}`);
        // },
        onError: (error: any) => {
          let message = "Something went wrong!";
          if (error?.response?.data?.message) {
            message = error.response.data.message;
          } else if (error?.message) {
            message = error.message;
          }
          toast.error(message);
        },
      }
    );
  };
  console.log(selectedCitiesArray, "selectedCitiesArray");
  useEffect(() => {
    if (selectedCoverageCountry?.id) {
      countryRefetch();
    }
  }, [selectedCoverageCountry]);
  useEffect(() => {
    if (selectedCoverageCity?.id) {
      districtRefetch();
    }
  }, [selectedCoverageCity]);

  useEffect(() => {
    if (warehouseDetails) {
      coverageReset({
        covrageName: warehouseDetails?.covrageName || "",
        covrageType: warehouseDetails?.covrageType || "",
      });
    }
  }, [warehouseDetails, coverageReset]);

  useEffect(() => {
    if (data?.length > 0) {
      setValue(
        "covrageCountry",
        data?.find((e: any) => e?.id === warehouseDetails?.covrageCountry)
      );
      setSelectedCoverageCountry(
        data?.find((e: any) => e?.id === warehouseDetails?.covrageCountry)
      );
      countryRefetch();
    }
  }, [data]);
  useEffect(() => {
    if (citiesData?.length > 0) {
      setValue(
        "covrageCity",
        citiesData?.find((e: any) => e?.id === warehouseDetails?.covrageCity)
      );
      setSelectedCoverageCity(
        citiesData?.find((e: any) => e?.id === warehouseDetails?.covrageCity)
      );
    }
  }, [citiesData]);
  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="rounded-2xl xl:w-7/12 lg:w-8/12 w-11/12 relative">
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h2 className="text-2xl">Edit Coverage Area</h2>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>
        <div className="w-full  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4 pt-0 p-4 scrollbar-clean">
            <div className="space-y-6 w-full">
              <div className="flex justify-between items-center pr-4">
                <h2 className="text-[#000000]/70 text-base">
                  Choose Bulk Upload
                </h2>
                <div className="flex items-center gap-1">
                  <ToggleButton
                    onChange={() => setChecked(!checked)}
                    checked={checked}
                  />
                  <h2 className="text-[#000000]/70 text-base">Bulk Upload</h2>
                </div>
              </div>
              {checked && (
                <>
                  {" "}
                  <div>
                    <FileUploader
                      name="document"
                      classNameMain="bg-white border border-dashed border-[#212121] rounded-2xl text-[#1E1E1E]/70"
                      title="Upload Your File"
                      message="Accepted formats: .xls, .xlsx, .csv | Max: 5MB"
                      placeHolder=""
                      img="/img/upload-img.png"
                      classNameImgDiv=" flex flex-col items-center justify-center text-[#1E1E1E]/70"
                    />
                  </div>
                  <ul className="list-disc px-6 text-[#1E293B] text-sm ">
                    <li>Download the Excel/CSV template before uploading. </li>
                    <li>Do not change column headers.</li>
                  </ul>
                  <div className="bg-[#ffffff] flex justify-between items-center px-4 py-1 rounded col-span-2 border-[0.5px]">
                    <p className="text-xs w-full">
                      <b className="font-medium">Note</b>: Please upload the
                      file in the same format as the downloaded file
                    </p>
                    <div className=" flex justify-end flex-shrink-0">
                      <button className="bg-[#000000] text-white px-4 py-2 rounded flex items-center gap-1 text-xs">
                        <img src="/img/csvxl.svg" alt="" />
                        <span>Download</span>
                      </button>
                    </div>
                  </div>{" "}
                </>
              )}
              {!checked && (
                <div className="grid grid-cols-2 gap-4">
                  {/* <Input
                    name="covrageName"
                    type="text"
                    title="Coverage Name"
                    placeholder="e.g. Central Riyadh, Western Jeddah"
                    // disabled
                    other={{
                      className:
                        "w-full space-y-1 px-4 py-2 text-sm rounded-full outline-none bg-white border border-[#D8D8D8]",
                    }}
                    register={coverageRegister}
                    error={coverageErrors?.covrageName}
                    validation={{
                      required: "Coverage name is required",
                      validate: (value: string) => {
                        const trimmed = value.trim();
                        if (trimmed.length < 3)
                          return "Coverage name must be at least 3 characters";
                        if (trimmed.length > 30)
                          return "Coverage name must be at most 30 characters";
                        return true;
                      },
                    }}
                  />{" "} */}
                  <Input
                    name="covrageName"
                    type="text"
                    title="Coverage Name"
                    placeholder="e.g. Central Riyadh, Western Jeddah"
                    register={coverageRegister}
                    error={coverageErrors?.covrageName}
                    validation={{
                      required: "Coverage name is required",
                      validate: (value: string) => {
                        const trimmed = value.trim();
                        if (trimmed.length < 3)
                          return "Coverage name must be at least 3 characters";
                        if (trimmed.length > 30)
                          return "Coverage name must be at most 30 characters";
                        return true;
                      },
                    }}
                    other={{
                      className:
                        "w-full space-y-1 px-4 py-2 text-sm rounded-full outline-none bg-white border border-[#D8D8D8]",
                    }}
                  />{" "}
                  <Radio
                    name="covrageType"
                    label="Select Coverage Type"
                    valuesArr={[
                      { value: "country", text: "Country" },
                      { value: "city", text: "City" },
                      { value: "district", text: "District" },
                    ]}
                    register={coverageRegister}
                  />
                  {(coverageWatch("covrageType") === "city" ||
                    coverageWatch("covrageType") === "district") && (
                    <SelectInput
                      name="covrageCountry"
                      className=""
                      label="Country"
                      placeholder=""
                      selectOptions={
                        data?.map((country: any) => ({
                          id: country?.id,
                          value: country?.name,
                          text: country?.name,
                        })) || []
                      }
                      register={coverageRegister}
                      clearErrors={coverageClearErrors}
                      disabled={!data || data.length === 0}
                      validation={{ required: "Please select a country" }}
                      error={coverageErrors?.covrageCountry}
                      value={selectedCoverageCountry?.name}
                      setValue={(val: string) => {
                        setValue(
                          "covrageCountry",
                          data.find((e: any) => e?.name === val)
                        );
                        setValue("covrageCity", "");
                        setSelectedCoverageCountry(
                          data.find((e: any) => e?.name === val)
                        );
                        setCoverageDataList([]);
                      }}
                    />
                  )}
                  {coverageWatch("covrageType") === "district" && (
                    <SelectInput
                      name="covrageCity"
                      label="Select City"
                      selectOptions={
                        citiesData?.map((city: any) => ({
                          id: city?.id,
                          value: city?.name,
                          text: city?.name,
                        })) || []
                      }
                      register={coverageRegister}
                      clearErrors={coverageClearErrors}
                      disabled={!citiesData || citiesData.length === 0}
                      validation={{ required: "City is required" }}
                      error={coverageErrors.covrageCity}
                      value={selectedCoverageCity?.name}
                      setValue={(val: string[]) => {
                        setValue(
                          "covrageCity",
                          citiesData.find((e: any) => e?.name === val)
                        );
                        setSelectedCoverageCity(
                          citiesData.find((e: any) => e?.name === val)
                        );
                        districtRefetch();
                        setCoverageDataList([]);
                      }}
                    />
                  )}
                  {(coverageWatch("covrageType") === "country" ||
                    (coverageWatch("covrageType") === "city" &&
                      coverageWatch("covrageCountry")) ||
                    (coverageWatch("covrageType") === "district" &&
                      coverageWatch("covrageCity"))) && (
                    <div className="rounded-lg col-span-2">
                      <CoverageCities
                        ALL_CITIES={
                          coverageWatch("covrageType") === "country"
                            ? data
                            : coverageWatch("covrageType") === "city"
                            ? citiesData
                            : districtData
                        }
                        selectedCityData={coverageDataList}
                        coverageType={coverageWatch("covrageType")}
                        coverageCity={coverageWatch("covrageCity")}
                        coverageCountry={coverageWatch("covrageCountry")}
                        setSelectedCitiesArray={setSelectedCitiesArray}
                        error={error}
                        setError={setError}
                        isEdit={false}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          <button
            onClick={coverageSubmit(handleCreate)}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
